import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory, createMemoryHistory } from 'history';
import rootReducer from './reducers/root';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const history =
  typeof window !== 'undefined'
    ? createBrowserHistory()
    : createMemoryHistory();

export type AppDispatch = typeof store.dispatch;
